export default {"src":"/_next/static/media/RefractiveErrors.d6a903a1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};